import { UPDATE_WATCH_LIST_ENTRY } from '../types';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  updateWatchListEntry,
  updateWatchListEntryPending,
  updateWatchListEntryFulfilled,
  updateWatchListEntryRejected,
} = createAsyncActions(UPDATE_WATCH_LIST_ENTRY, 'updateWatchListEntry');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/updateWatchListEntryActions.js